module.exports = __webpack_public_path__ + "media/obstacleDeath.c18a50b0.mp3";